import { Outlet, createFileRoute } from '@tanstack/react-router';
import { MarketingLayout } from '@/components/marketing/MarketingLayout';

export const Route = createFileRoute('/_marketing')({
  component: MarketingShell,
});

function MarketingShell() {
  return (
    <MarketingLayout>
      <Outlet />
    </MarketingLayout>
  );
}
